import { render, staticRenderFns } from "./ListOrdersServices.vue?vue&type=template&id=04a135fe&"
import script from "./ListOrdersServices.vue?vue&type=script&lang=js&"
export * from "./ListOrdersServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports